<wms-dialog-header title="{{ locale['LABEL_UPGRADE_PREFAB_DIALOG_TITLE']}}"
    (onClose)="closeDialog()"></wms-dialog-header>
<wms-dialog-body>
    {{prefabUpdate.conflictMessage}}
</wms-dialog-body>
<wms-dialog-footer>
    <button class="btn button-primary" name="wm-update-reload-prefab"
        (click)="dialogParams.resolve.upgradeFn()">{{locale['LABEL_UPGRADE_PREFAB_DIALOG_UPDATE_RELOAD'].replace('${0}', [
        prefabUpdate.actionsBtnMsg
        ])}}</button>
    <button class="btn btn-primary" (click)="dialogParams.resolve.onSkipUpgrade()">{{locale['LABEL_SKIP_UPGRADE_PREFAB_DIALOG']}}</button>
</wms-dialog-footer>